import React from "react";
import { useRef, useState, useEffect } from "react";
import GetInTouchForm from "../GetinTouchform/GetinTouch";
import useTheme from "../ColorConfig/usetheme";



function Readytostart(){

  const colors = useTheme();
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const sectionRef = useRef(null);
  const componentId = useRef(`ready-to-start-${Date.now()}`);

  const handleContactClick = (e) => {
    e.preventDefault();
    setShowGetInTouch(true);
  };

  const closeGetInTouch = () => {
    setShowGetInTouch(false);
  };

  // Generate more bubbles with better distribution
  const generateBubbles = () => {
    const bubbles = [];
    const bubbleCount = 50;
    
    for (let i = 1; i <= bubbleCount; i++) {
      const isLight = Math.random() > 0.4;
      const size = 20 + Math.random() * 200;
      const left = Math.random() * 100;
      const top = Math.random() * 100;
      const opacity = isLight ? 0.08 + Math.random() * 0.15 : 0.15 + Math.random() * 0.25;
      const duration = 15 + Math.random() * 25;
      const delay = Math.random() * 10;
      
      bubbles.push({
        id: i,
        size,
        left: `${left}%`,
        top: `${top}%`,
        delay: `${delay}s`,
        duration: `${duration}s`,
        opacity,
        type: isLight ? 'light' : 'dark'
      });
    }
    
    return bubbles;
  };

  const backgroundBubbles = generateBubbles();

  const BackgroundBubble = ({ bubble }) => {
    const isLight = bubble.type === 'light';
    const bubbleStyle = {
      position: 'absolute',
      width: `${bubble.size}px`,
      height: `${bubble.size}px`,
      left: bubble.left,
      top: bubble.top,
      borderRadius: '50%',
      background: isLight 
        ? `radial-gradient(circle at 30% 30%, rgba(255,255,255,${bubble.opacity * 1.5}), rgba(255,255,255,${bubble.opacity * 0.3}), transparent 70%)`
        : `radial-gradient(circle at 30% 30%, rgba(0,0,0,${bubble.opacity}), rgba(0,0,0,${bubble.opacity * 0.2}), transparent 70%)`,
      animation: `bubbleFloat${componentId.current}_${bubble.id} ${bubble.duration} ease-in-out infinite`,
      animationDelay: bubble.delay,
      zIndex: 1,
      filter: isLight ? 'blur(1px)' : 'blur(0.5px)',
      pointerEvents: 'none',
      willChange: 'transform',
      opacity: bubble.opacity // Keep consistent opacity
    };

    return <div style={bubbleStyle} />;
  };

  // Generate keyframes for bubble animations with scoped names - SIMPLIFIED VERSION
  const generateKeyframes = () => {
    let keyframes = '';
    
    backgroundBubbles.forEach(bubble => {
      // Simplified movement - just gentle floating
      const moveX = -15 + Math.random() * 30;
      const moveY = -15 + Math.random() * 30;

      keyframes += `
        @keyframes bubbleFloat${componentId.current}_${bubble.id} {
          0%, 100% { 
            transform: translate(0px, 0px);
          }
          25% { 
            transform: translate(${moveX * 0.5}px, ${moveY * 0.5}px);
          }
          50% { 
            transform: translate(${moveX}px, ${moveY}px);
          }
          75% { 
            transform: translate(${moveX * 0.3}px, ${moveY * 0.8}px);
          }
        }
      `;
    });

    return keyframes;
  };

  return(
    <>
      <div 
        className="ready-to-start-section position-relative overflow-hidden w-100" 
        style={{ 
          background: `
            radial-gradient(ellipse at top left, ${colors.primary} 0%, ${colors.primaryHover} 50%, ${colors.primaryLight} 100%),
            linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryHover} 25%, ${colors.primaryLight} 50%, ${colors.primaryTransparent} 75%, ${colors.primaryLight} 100%)
          `,
          height: '350px',
          margin: '0'
        }}
      >
        {/* Enhanced Animated Background with Gradient Overlay */}
        <div 
          className="position-absolute w-100 h-100" 
          style={{
            background: `
              radial-gradient(ellipse at 20% 30%, rgba(${colors.primaryRgb}, 0.4) 0%, transparent 60%),
              radial-gradient(ellipse at 80% 70%, rgba(${colors.primaryRgb}, 0.3) 0%, transparent 60%),
              radial-gradient(ellipse at 60% 40%, rgba(${colors.primaryRgb}, 0.35) 0%, transparent 50%),
              linear-gradient(45deg, transparent 20%, rgba(${colors.primaryRgb}, 0.2) 40%, transparent 60%)
            `,
            zIndex: 2,
            animation: `gradientShift_${componentId.current} 8s ease-in-out infinite alternate`
          }}
        />

        {/* Background Bubbles */}
        <div className="position-absolute w-100 h-100" style={{ zIndex: 1 }}>
          {backgroundBubbles.map((bubble) => (
            <BackgroundBubble key={bubble.id} bubble={bubble} />
          ))}
        </div>

        {/* Floating Particles */}
        <div className="position-absolute w-100 h-100" style={{ zIndex: 3 }}>
          {Array.from({ length: 20 }, (_, i) => (
            <div
              key={`particle-${i}`}
              style={{
                position: 'absolute',
                width: '3px',
                height: '3px',
                background: 'rgba(255, 255, 255, 0.6)',
                borderRadius: '50%',
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `floatParticle_${componentId.current}_${i} ${15 + Math.random() * 10}s linear infinite`,
                animationDelay: `${Math.random() * 5}s`,
                pointerEvents: 'none'
              }}
            />
          ))}
        </div>

        {/* Main Content */}
        <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 4 }}>
          <div className="text-center px-1">
            <h5 
              className="fw-bold mb-3" 
              style={{ 
                color: colors.white, 
                fontSize: 'clamp(2.0rem, 3vw, 3rem)',
                lineHeight: '1.2',
                letterSpacing: '-0.02em',
                // animation: `titleGlow_${componentId.current} 3s ease-in-out infinite alternate`,
                // textShadow: '0 4px 20px rgba(0,0,0,0.5), 0 0 40px rgba(255,255,255,0.3)'
              }}
            >
              Ready to Transform Your Business!
            </h5>
            <h6 
              className="lead" 
              style={{ 
                color: colors.white,
                fontSize: 'clamp(1.0rem, 2.0vw, 1.2rem)',
                maxWidth: '800px',
                margin: '0 auto 3rem auto',
                lineHeight: '1.6',
                fontWeight: '300',
                textShadow: '0 2px 10px rgba(0,0,0,0.3)'
              }}
            >
              Schedule a personalized demo and discover how our solutions can revolutionize your operations.
            </h6>
            
            <div className="d-flex justify-content-center">
              <button 
                className={`btn btn-lg px-4 py-3 position-relative overflow-hidden ready-to-start-btn ready-to-start-btn-${componentId.current}`}
                style={{
                  background: 'rgba(255, 255, 255, 0.15)',
                  color: colors.white,
                  border: `2px solid rgba(255, 255, 255, 0.3)`,
                  borderRadius: '50px',
                  fontSize: '1.0rem',
                  fontWeight: '800',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  backdropFilter: 'blur(15px)',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  minWidth: '200px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                  cursor: 'pointer'
                }}
                onClick={handleContactClick}
              >
                Start Your Project
                <span 
                  className={`position-absolute top-0 start-0 w-100 h-100 shine-effect-${componentId.current}`}
                  style={{
                    background: 'linear-gradient(45deg, transparent 30%, var(--color-primary) 50%, transparent 70%)',
                    transform: 'translateX(-100%)',
                    transition: 'transform 0.8s ease',
                    borderRadius: '50px'
                  }}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Enhanced Decorative Elements */}
        <div 
          className="position-absolute"
          style={{
            bottom: '0',
            left: '0',
            right: '0',
            height: '50px',
            background: `linear-gradient(to top, rgba(0,0,0,0.1), transparent)`,
            zIndex: 5
          }}
        />
      </div>

     {showGetInTouch && (
              <div className="modal-overlay" onClick={closeGetInTouch}>
                <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
                  <button className="close-button" onClick={closeGetInTouch}>
                    &times;
                  </button>
                  <GetInTouchForm isModal={true} />
                </div>
              </div>
            )}

      {/* Scoped Styles - No Global CSS Conflicts */}
      <style jsx>{`
        ${generateKeyframes()}
        
        /* Scoped gradient animation */
        @keyframes gradientShift_${componentId.current} {
          0% { 
            opacity: 0.8; 
            transform: scale(1) rotate(0deg);
          }
          50% { 
            opacity: 1; 
            transform: scale(1.05) rotate(2deg);
          }
          100% { 
            opacity: 0.9; 
            transform: scale(1.02) rotate(-1deg);
          }
        }
        
        /* Scoped floating particles animation */
        ${Array.from({ length: 20 }, (_, i) => `
          @keyframes floatParticle_${componentId.current}_${i} {
            0% { 
              transform: translateY(100%) translateX(0px); 
              opacity: 0; 
            }
            10% { 
              opacity: 1; 
            }
            90% { 
              opacity: 1; 
            }
            100% { 
              transform: translateY(-100%) translateX(${(Math.random() - 0.5) * 100}px); 
              opacity: 0; 
            }
          }
        `).join('')}
        
        @keyframes titleGlow_${componentId.current} {
          0% { 
            text-shadow: 0 4px 8px rgba(0,0,0,0.5), 0 0 20px rgba(255,255,255,0.1); 
            transform: scale(1);
          }
          100% { 
            text-shadow: 0 4px 8px rgba(0,0,0,0.5), 0 0 40px rgba(255,255,255,0.3); 
            transform: scale(1.02);
          }
        }
        
        /* Scoped button hover effects */
        .ready-to-start-btn-${componentId.current}:hover {
          transform: translateY(-8px) scale(1.08) !important;
          background: rgba(255, 255, 255, 0.25) !important;
          border-color: rgba(255, 255, 255, 0.6) !important;
          box-shadow: 0 20px 60px rgba(255, 255, 255, 0.3) !important;
        }
        
        .ready-to-start-btn-${componentId.current}:hover .shine-effect-${componentId.current} {
          transform: translateX(100%) !important;
        }
        
        .ready-to-start-btn-${componentId.current}:active {
          transform: translateY(-4px) scale(1.05) !important;
        }
        
        /* Scoped smooth transitions - only for this component */
        .ready-to-start-section * {
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          -webkit-transform-style: preserve-3d;
          transform-style: preserve-3d;
        }
      `}</style>
    </>
  )
}

export default Readytostart;